import {UpmEntityType} from '@hconnect/common/types'
import type {Data, Node} from 'unist'

export enum StorageDepartmentNodeKey {
  FuelsSiloStorage = 'Fuels_SiloStorage',
  AuxiliaryMaterialStorageSilos = 'Auxiliary_MaterialStorageSilos',
  QuarryMaterialStorage = 'Quarry_MaterialStorage',
  CrushingRawMaterialRawMaterialStorage = 'CrushingRawMaterial_RawMaterialStorage',
  RawMaterialPreparationRawMealSilo = 'RawMaterialPreparation_RawMealSilo',
  ClinkerProductionClinkerStorage = 'ClinkerProduction_ClinkerStorage',
  CementGrindingCementSilos = 'CementGrinding_CementSilos',
  PackingLoadingProductStorage = 'PackingLoading_ProductStorage'
}

export enum StorageEquipmentNodeKey {
  Bin = 'Bin',
  Bucket = 'Bucket',
  HopperBin = 'HopperBin',
  ReservoirAirReceiverGasTank = 'ReservoirAirReceiverGasTank',
  StorageSilo = 'StorageSilo',
  TankWaterOilOthers = 'TankWaterOilOthers',
  Wagon = 'Wagon'
}

export interface EntityProperty {
  code: string
  name: string
}
export interface StructureNodeData extends Data {
  id: string
  upmId: string
  name: string
  signalCount: number
  entityProperties?: EntityProperty
  entityLabel: string
}
export interface StructureNodeUnist extends Node {
  entityType: UpmEntityType
  data: StructureNodeData
  children?: StructureNodeUnist[]
  entityProperties?: EntityProperty
}

export interface StructureNodeUnistWithAncestors extends StructureNodeUnist {
  ancestors: StructureNodeUnist[]
}

export type PlantDetails = {
  sourceId: string
  siteId: string
  plantId: string
  name: string
  city: string
  street: string
  postCode: string
  region: string
  country: string
  longitude: string
  latitude: string
  timezone: string
  locationId: string
  source: string
  upmId: string
  id: string
}
